import React, { FunctionComponent, useCallback } from 'react';
import { useStore } from 'effector-react';
import { pageSizeOptions } from '@constants/pagination';
import css from './UserDetailComments.module.less';
import UserCommentCard from '@components/UserCommentCard';
import { Pagination } from 'antd';
import userComments, { getComments } from '@stores/userComments';
import { useParams } from 'react-router';
import IUser from '@interfaces/IUser';

interface UserDetailCommentsProps {}

const UserDetailComments: FunctionComponent<UserDetailCommentsProps> = () => {
  const { userId } = useParams<{ userId: IUser['id'] }>();
  const { commentsList, pagination } = useStore(userComments);

  const paginationChange = useCallback((current: number, pageSize?: number) => {
    getComments({ userId: userId, pagination: { current, pageSize } });
  }, []);
  return (
    <div className={css.root}>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          onChange={paginationChange}
          showSizeChanger
          pageSizeOptions={pageSizeOptions}
        />
      </div>
      {commentsList.map((comment) => (
        <UserCommentCard
          key={comment.id}
          comment={comment}
        />
      ))}

      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          onChange={paginationChange}
          showSizeChanger
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </div>
  );
};

export default UserDetailComments;
